export default {"src":"/_next/static/media/chart-bar.a1d26619.svg","height":192,"width":192};